/*
  Makes it easy to detect when the user is pressing a specific key on their keyboard
  Ex: const { image, isLoading, isError } = usePortalUserImage(userId);
*/

import { useState, useEffect } from 'react';
import { useMountedState } from 'react-use';
import { queryUserImage } from 'services/requests';
import { CancelToken, isCancel } from 'axios'

function usePersonImage(userId) {
  const [image, setImage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const isMounted = useMountedState();

  useEffect(() => {
    const sourceUser = CancelToken.source();
    const sourceAvatar = CancelToken.source();
    // eslint-disable-next-line no-unused-vars
    async function fetchUserAvatar() {
      setIsLoading(true)
      try {
        if (userId) {
          const imageData = await queryUserImage(userId, { cancelToken: sourceAvatar.token })
          const hasImage = imageData && imageData.data && imageData.data.byteLength > 0
          const userImage = hasImage ? `data:image/jpeg;base64,${Buffer.from(imageData.data, 'binary').toString('base64')}` : null
          setImage(userImage)
          setIsLoading(false)
          setIsError(false)
        } else {
          setImage(null)
          setIsLoading(false)
          setIsError(true)
        }
      } catch (err) {
        const cancelled = isCancel(err)
        if (!cancelled && isMounted) {
          // error wasn't due to cancelling
          setIsLoading(false)
          setImage(null)
          setIsError(true)
        }
      }
    }
    fetchUserAvatar()

    // cleanup function that cancels pending requests
    return () => {
      sourceUser.cancel()
      sourceAvatar.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return {
    image,
    isLoading,
    isError,
  };
}

export default usePersonImage;
